<div class="row mx-auto">
	<div class="p-2 col-6" [attr.data-tooltip]="i?.tileText" *ngFor="let i of props">
		<div class="" id="weeklyad_tile">
			<a  href="{{i?.tileURL}}" class="launchpad-button" (click)="analyticsEventsOnClick(i?.tileHeading)">
				<div class="launchpad-button-img">
					<foru-plus-logo *ngIf="i?.tileURL === '/foruplus'"
					                height="48px"
					                [banner]="banner"
					                [decorative]="true">
					</foru-plus-logo>
					<img *ngIf="i?.tileURL !== '/foruplus'" class="launchpad-icon" src="{{i?.tileImg}}" alt="">
				</div>
				<div class="launchpad-button-text mt-2">
					<p class="launchpad-title mb-1" [attr.aria-label]="i?.tileHeading + ' ' + i?.tileText">{{i?.tileHeading}}</p>
					<p class="launchpad-text" aria-hidden="true">{{i?.tileText}}</p>
				</div>
				<div class="svg-chevron-right-icon"></div>
			</a>
		</div>
	</div>
</div>